
import { Component } from '@angular/core';
import { ShareMenuComponent } from '../share-menu-component';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html'
})
export class SidebarNavComponent extends ShareMenuComponent {

 
}

